/* unplugin-vue-components disabled */import { render } from "./member_userCard_m.vue?vue&type=template&id=7c2ad10c&scoped=true"
import script from "./member_userCard_m.vue?vue&type=script&lang=js"
export * from "./member_userCard_m.vue?vue&type=script&lang=js"

import "./member_userCard_m.vue?vue&type=style&index=0&id=7c2ad10c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2ad10c"]])

export default __exports__